import '../../assets/entity-list.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { ServiceListDto } from '../../general/dtos';
import { useServices } from '../../providers/services-provider';
import { Link, useLocation } from 'react-router-dom';

export function ServiceList({ onServiceSelected }: { onServiceSelected?: () => void }) {
    const { services, selectedKey, selectService, loading, error, reloadList } = useServices();
    const location = useLocation();
    const serviceTitle = (service: ServiceListDto) => {
        const params = new URLSearchParams(location.search);
        params.set('service', service.service_key);
        return <Link to={`${location.pathname}?${params.toString()}${location.hash}`}
            className="service-title-link"
            onClick={event => {
                // Let the link handle navigation, preserving native new-tab behaviour.
                event.stopPropagation();
                if (event.button === 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
                    onServiceSelected?.();
                }
            }}>{service.name}</Link>;
    };
    return <div className="entity-list-container">
        {error && <div className="p-3" role="alert">
            <p>{error}</p><Button label="Retry" icon="pi pi-refresh" onClick={reloadList} />
        </div>}
        <div className="entity-list-wrapper">
            <DataTable value={services} dataKey="service_key" loading={loading} selectionMode="single"
                selection={services.find(service => service.service_key === selectedKey) ?? null}
                onSelectionChange={event => {
                    const service = event.value as ServiceListDto | null;
                    if (service) {
                        selectService(service.service_key);
                        onServiceSelected?.();
                    }
                }}
                onRowClick={event => {
                    const service = event.data as ServiceListDto;
                    if (service.service_key === selectedKey) onServiceSelected?.();
                }}
                scrollable scrollHeight="flex" filterDisplay="menu" removableSort
                emptyMessage={error ? 'Services are currently unavailable.' : 'There are no services available.'}>
                <Column field="name" header="Service" body={serviceTitle} sortable filter />
            </DataTable>
        </div>
    </div>;
}
